// extracted by mini-css-extract-plugin
export default {"productGallery":"RL-z","inQuickShop":"SL-z"};